import BukuNilai from "../../../../../components/categories/siakad/lms/data_buku_nilai/Home";
export default function Home() {
  
  return (
    <BukuNilai />
  );
}
